import Vue from "vue";
import { Plugin } from "vue-fragment";
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import JSONViewComponent from "vue-json-component";

Vue.use(VueFormWizard);
Vue.use(Plugin);
Vue.use(JSONViewComponent);
